import { STATUS_ACTIVE } from "@/constants/products";

export default {
  type: "products",
  name: null,
  sku: null,
  barcode: null,
  pos_department_code: null,
  pos_department_name: null,
  status: STATUS_ACTIVE,
  excerpt: "",
  buying_price: 0,
  selling_price: 0,
  picture: null,
  gallery: [],
  taxGroups: [],
  can_be_sold: false,
  can_be_purchased: false,
  has_deposit: false,
  deposit_amount: 0,
  buying_deposit_amount: 0,
  relationshipNames: [
    "organization",
    "allowedLocations",
    "categories",
    "taxGroups",
    "unitOfMeasure",
    "orderUnitOfMeasureUnit",
  ],
  organization: {
    type: "organizations",
    id: null,
  },
  unitOfMeasure: {
    type: "unit-of-measures",
    id: null,
  },
  orderUnitOfMeasureUnit: {
    type: "unit-of-measure-units",
    id: null,
  },
  allowedLocations: [],
  categories: [],
  backorder_note: null,
};
